import React from "react";
import "./Orders.css";

function Orders(){
    return <div className="orders">Orders</div>;
}

export default Orders;